import { lazy, Suspense } from "react";
import type { RouteObject } from "react-router-dom";
import LoadingFallback from "../components/feature/LoadingFallback";

// Lazy load all pages
const NotFound = lazy(() => import("../pages/NotFound"));
const Home = lazy(() => import("../pages/home/page"));
const FileTemplates = lazy(() => import("../pages/file-templates/page"));
const DutyReport = lazy(() => import("../pages/duty-report/page"));
const ReportData = lazy(() => import("../pages/report-data/page"));
const BedLayout = lazy(() => import("../pages/bed-layout/page"));
const Feedback = lazy(() => import("../pages/feedback/page"));
const TreatmentProtocols = lazy(() => import("../pages/treatment-protocols/page"));
const ServicesPage = lazy(() => import("../pages/services/page"));
const StatisticsPage = lazy(() => import("../pages/statistics/page"));
const EpidemicPage = lazy(() => import("../pages/epidemic/page"));
const DataNotebookPage = lazy(() => import("../pages/data-notebook/page"));
const TrainingSchedulePage = lazy(() => import("../pages/training-schedule/page"));
const TransferRegistryPage = lazy(() => import("../pages/transfer-registry/page"));
const NavigationAdminPage = lazy(() => import("../pages/navigation-admin/page"));
const NavigationPage = lazy(() => import("../pages/navigation/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <Home />
      </Suspense>
    ),
  },
  {
    path: "/bed-layout",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <BedLayout />
      </Suspense>
    ),
  },
  {
    path: "/duty-report",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <DutyReport />
      </Suspense>
    ),
  },
  {
    path: "/report-data",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <ReportData />
      </Suspense>
    ),
  },
  {
    path: "/file-templates",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <FileTemplates />
      </Suspense>
    ),
  },
  {
    path: "/feedback",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <Feedback />
      </Suspense>
    ),
  },
  {
    path: "/treatment-protocols",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <TreatmentProtocols />
      </Suspense>
    ),
  },
  {
    path: "/services",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <ServicesPage />
      </Suspense>
    ),
  },
  {
    path: "/statistics",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <StatisticsPage />
      </Suspense>
    ),
  },
  {
    path: "/epidemic",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <EpidemicPage />
      </Suspense>
    ),
  },
  {
    path: "/data-notebook",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <DataNotebookPage />
      </Suspense>
    ),
  },
  {
    path: "/training-schedule",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <TrainingSchedulePage />
      </Suspense>
    ),
  },
  {
    path: "/transfer-registry",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <TransferRegistryPage />
      </Suspense>
    ),
  },
  {
    path: "/navigation-admin",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <NavigationAdminPage />
      </Suspense>
    ),
  },
  {
    path: "/navigation",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <NavigationPage />
      </Suspense>
    ),
  },
  {
    path: "*",
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <NotFound />
      </Suspense>
    ),
  },
];

export default routes;